import React, { useState } from 'react';
import { usePrefs, useLabels, useFlags } from 'ws-scripts/modules/common';
import { useSelector } from 'react-redux';
import { setClassNames } from '@ddc/classnames-js';
import { useRequestData } from 'wsm-common-data';
import AllReviewsModal from './AllReviewsModal';

const Footer = () => {
	const [isOpenModal, setOpenModal] = useState(false);
	const kbbCustomerRatings = useSelector((state) => state.ratings);
	const reviews = useSelector((state) => state.reviews);
	const { useHorizontalStyle, useInverseTextColor } = usePrefs();
	const isShowAllReviews = (reviews?.items?.length || 0) > 2;
	const labels = useLabels();
	const flags = useFlags();
	const isUseResearchableAPI = flags['ws-kbb-reviews-use-researchable-api'];
	const { deviceType } = useRequestData();
	const isMobile = deviceType === 'MOBILE';
	const {
		numberOfReviews: totalReviews,
		generationStartYear: startYear,
		generationEndYear: endYear
	} = kbbCustomerRatings;

	const determineStartEndYear = (y1, y2) => {
		const currentYear = new Date().getFullYear();
		const start = String(y1 === 'current' ? currentYear : y1);
		const end = String(y2 === 'current' ? currentYear : y2);
		const separator = !start || !end ? '' : '–';
		return start === end ? start : `${start}${separator}${end}`;
	};
	const toggleOpenModal = () => {
		setOpenModal((previous) => !previous);
	};

	const enableHorizontalLayout = useHorizontalStyle === 'true';
	const textMutedColor =
		useInverseTextColor === 'true' ? 'text-muted-inverse' : 'text-muted';

	let textLinkColor = '';
	if (useInverseTextColor === 'true') {
		textLinkColor = enableHorizontalLayout
			? 'text-muted-inverse'
			: 'text-link-inverse';
	} else if (enableHorizontalLayout) {
		textLinkColor = 'text-muted';
	}

	const footerClasses = [
		'kbb-footer',
		'mt-3',
		enableHorizontalLayout ? 'ddc-font-size-xsmall' : ''
	];

	const privacyClasses = [
		'kbb-privacy-link',
		textLinkColor,
		enableHorizontalLayout ? 'ml-3' : '',
		enableHorizontalLayout ? 'text-decoration-underline' : ''
	];

	const iconLaunchClasses = setClassNames([
		'ddc-icon',
		'ddc-icon-launch',
		isMobile ? 'ddc-font-size-xlarge mt-1' : 'ddc-font-size-large mr-4',
		'ml-3'
	]);

	const yearRange = determineStartEndYear(startYear, endYear);
	let separator = ' ';
	if (!enableHorizontalLayout) {
		if (isMobile) {
			separator = ' | '; 
		} else {
			separator = ' |\u00A0'; 
		}
	}
	const footerText = `Based on ${totalReviews} consumer ratings for ${yearRange} models.${separator}`;

	return (
		<div className={setClassNames(footerClasses)}>
			{isUseResearchableAPI && isShowAllReviews && (
				<div
					className={`d-inline-flex align-items-baseline ${isMobile ? 'mb-4' : ''}`}
					onClick={toggleOpenModal}
					onKeyPress={(e) => e.key === 'Enter' && toggleOpenModal()}
					role="button"
					tabIndex={0}
				>
					<span className="text-decoration-underline font-weight-normal">
						{labels.get('ALL_REVIEWS_ON_KBB.COM')}
					</span>
					<i className={iconLaunchClasses} />
				</div>
			)}
			<div className="d-block d-lg-inline-flex">
				{!!totalReviews && startYear && endYear && (
					<span className={`kbb-footer-text ${textMutedColor}`}>
						{footerText}
					</span>
				)}

				<a
					className={setClassNames(privacyClasses)}
					target="_blank"
					rel="noopener noreferrer"
					href="https://www.kbb.com/company/privacy-policy/"
				>
					Privacy
				</a>
			</div>

			{isOpenModal && isUseResearchableAPI && (
				<AllReviewsModal
					reviews={reviews.items}
					onClose={toggleOpenModal}
					isOpen={isOpenModal}
				/>
			)}
		</div>
	);
};

export default Footer;
